import { render, staticRenderFns } from "./ClientCardProductPriceQtty.vue?vue&type=template&id=673cea6d&scoped=true&"
import script from "./ClientCardProductPriceQtty.vue?vue&type=script&lang=js&"
export * from "./ClientCardProductPriceQtty.vue?vue&type=script&lang=js&"
import style0 from "./ClientCardProductPriceQtty.vue?vue&type=style&index=0&id=673cea6d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673cea6d",
  null
  
)

export default component.exports